/**
 * page10-B (#435) — batch-csoportnézet hook.
 * Az azonos `intakeBatchId`-jű munkalapok a meglévő lista-endpoint
 * `?intakeBatchId=` szűrőjével jönnek (max 26 al-szám: ML-…-A–Z).
 */

import { getWorksheets, type Worksheet } from '@/api/worksheets';
import { useCallback, useEffect, useState } from 'react';

export function useBatchWorksheets(intakeBatchId: string | undefined): {
  batchWorksheets: Worksheet[];
  isLoading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
} {
  const [batchWorksheets, setBatchWorksheets] = useState<Worksheet[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchBatch = useCallback(async () => {
    if (!intakeBatchId) {
      setBatchWorksheets([]);
      return;
    }
    setIsLoading(true);
    setError(null);
    try {
      const response = await getWorksheets({ intakeBatchId, pageSize: 26 });
      setBatchWorksheets(response.data);
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to fetch batch worksheets';
      setError(message);
      console.error('Error fetching batch worksheets:', err);
    } finally {
      setIsLoading(false);
    }
  }, [intakeBatchId]);

  useEffect(() => {
    void fetchBatch();
  }, [fetchBatch]);

  return { batchWorksheets, isLoading, error, refetch: fetchBatch };
}
